import HttpService from "../base/HttpService";
export default class AuthService extends HttpService {
  static api = process.env.VUE_APP_BASE_API;
  postlogin(param) {
    const api = this.api + "auth/exchange";

    return this.post(param, api);
  }

  logout() {
    const api = this.api + "auth/logout";

    return this.post({}, api);
  }
}
